module.exports = __webpack_public_path__ + "static/img/S8.a982529a.png";